import { getScene7ImageURL } from '../impl/getScene7ImageUrl';
import { getScene7VideoRenditionURL } from '../impl/getScene7VideoRenditionUrl';
import { getImageSrcSet } from '../impl/getImageSrcSet';
import { getRemoteDynamicMediaUrl } from '../impl/getRemoteDynamicMediaUrl';
import { defaultConfigValues, defaultScene7ConfigValues } from '../v1';
export class ImageServiceV2Impl {
    constructor(inputConfig, logger) {
        this.logger = logger;
        this.config = Object.assign(Object.assign(Object.assign({}, defaultConfigValues), inputConfig), { scene7Config: Object.assign(Object.assign({}, defaultScene7ConfigValues), inputConfig.scene7Config) });
    }
    getImageURL(requestedImage, requiredWidth) {
        if (requestedImage.imageSourceType == 'scene7' ||
            !requestedImage.imageSourceType) {
            return getScene7ImageURL(requestedImage, requiredWidth, this.config, this.logger);
        }
        if (requestedImage.imageSourceType === 'remote-dynamic-media') {
            return getRemoteDynamicMediaUrl(requestedImage, requiredWidth, this.config.rdmConfig);
        }
        return requestedImage.contentFile;
    }
    getVideoRenditionURL(requestedRendition) {
        return getScene7VideoRenditionURL(requestedRendition, this.config);
    }
    getImageSrcSet(requestedImage) {
        if (requestedImage.imageSourceType == 'scene7') {
            return getImageSrcSet(this.config.maxWidth, width => {
                return getScene7ImageURL(requestedImage, width, this.config, this.logger);
            });
        }
        if (requestedImage.imageSourceType === 'remote-dynamic-media') {
            return getImageSrcSet(this.config.maxWidth, width => {
                return getRemoteDynamicMediaUrl(requestedImage, width, this.config.rdmConfig);
            });
        }
        return '';
    }
}
